/* ============================================================================
   is-regole-packaging.js — le funzioni condivise che scrivono sul carrello.

   Era stampato dentro <script> da DUE chiamanti (is-packaging e cart-summary):
   nella stessa pagina finiva due volte, ~11 KB per copia. Ora e' un file solo,
   scaricato una volta e tenuto in cache.

   is-regole-packaging.liquid — come si legge il carrello, dove mandano i pulsanti, e come si
   ridisegna senza ricaricare. Funzioni condivise fra i componenti.
   
   LE TRE FAMIGLIE DI CONFEZIONE (vedi _tema-barra-premi/CONFEZIONI-PER-COLLEZIONE.md)
   - `barattoli`  calze sottili: cofanetto singolo per un paio, doppio per due
   - `stirato`    sport 34 € e cashmere blend 39 €: un paio riempie gia' il cofanetto doppio,
   che e' incluso nel prezzo. Due paia = due cofanetti, non uno doppio
   - `extrafine`  57-61 €: cofanetto incluso, singolo per un paio e doppio per due uguali
   
   COME SI RICONOSCE LA FAMIGLIA, e perche' in due modi:
   la verita' sta nel metafield `custom.confezione`, ma cart.js non restituisce i metafield.
   Il Liquid di is-packaging costruisce percio' una mappa handle -> famiglia leggendo le
   collezioni sport e cashmere (Liquid non puo' scorrere piu' di 50 prodotti per collezione,
   quindi non si puo' passare tutto il catalogo).
   Per i prodotti fuori da quelle collezioni c'e' la rete di sicurezza del PREZZO: 34 e 39 €
   sono stirati, da 57 in su sono extrafine. Cosi' nessun prodotto sfugge, e il giorno che il
   listino cambia comanda comunque il metafield.
   
   ⚠ LE COPPIE SI CONTANO LETTERA PER LETTERA (corretto il 20/8). Prima una famiglia si
   considerava "da appaiare" solo se TUTTE le sue paia avevano le stesse iniziali: bastava un
   paio con lettere diverse e si perdevano le confezioni doppie per tutti. Due paia "A-B" piu'
   una "C-D" davano tre confezioni singole, invece di una doppia piu' una singola. Ora le coppie
   si contano dentro ogni gruppo di lettere e poi si sommano.
   
   ⚠ QUANDO SHOPIFY DICE DI NO, SI RIPETE QUELLO CHE HA DETTO. Certe lettere sono esaurite su
   certi modelli — il magazzino e' per singola calza, A_101 e X_101 sono due SKU diversi — e
   l'aggiunta torna indietro con 422. `scrivi` porta con se' il messaggio del server, gia'
   tradotto, cosi' il componente puo' dire al cliente che quel modello con quelle iniziali e'
   finito, invece del generico "Riprova".
   
   ⚠ RIDISEGNO SENZA RICARICARE. Nel pannello laterale un reload butta fuori il cliente proprio
   mentre stava per premere Check-out. Il tema Horizon usa la Section Rendering API: manda
   `sections` e `sections_url` e si riprende l'HTML gia' renderizzato. Facciamo lo stesso.
   ========================================================================= */
window.ISRegolePackaging = (function(){
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function lettera(v){
    var m = String(v || '').match(/([A-Za-zÀ-ſ])/);
    return m ? m[1].toUpperCase() : null;
  }
  function eAccessorio(it){
    var T = String(it.title || '').toUpperCase();
    return T.indexOf('COFANETTO') > -1 || T.indexOf('GIFT PACK') > -1 || T.indexOf('WOOD BOX') > -1;
  }
  function inizialiDi(item){
    var p = item.properties || {}, sx = null, dx = null, nomeSx = null, nomeDx = null,
        vSx = null, vDx = null, bundle = null, nomeBundle = null;
    Object.keys(p).forEach(function(k){
      var K = k.toUpperCase();
      if (K.indexOf('BUNDLE_SELECTION') > -1) { bundle = p[k]; nomeBundle = k; }
      else if (K.indexOf('SINISTRA') > -1 || K.indexOf('LEFT') > -1) { sx = lettera(p[k]); nomeSx = k; vSx = p[k]; }
      else if (K.indexOf('DESTRA') > -1 || K.indexOf('RIGHT') > -1) { dx = lettera(p[k]); nomeDx = k; vDx = p[k]; }
    });
    if (!sx || !dx) return null;
    /* Cosa far leggere al cliente. Sulle Design Edition una calza porta un disegno, non una
       lettera: la property vale per esempio "Racchette Tennis Ricamo Verde". La funzione
       lettera() qui sopra ne pesca la prima lettera, e il carrello finiva per scrivere "R-A".
       Regola del 28/08/2026: dove c'e' un disegno si scrive "Design", cosi' il cliente legge
       "Design-A" e non un'iniziale che non ha scelto.
       Come si riconosce: si contano le lettere del valore scelto. Una sola = iniziale, molte =
       nome di un ricamo. Non guarda le etichette, quindi vale in tutte e cinque le lingue. */
    function daMostrare(valore, letteraTrovata){
      var pulito = String(valore || '').replace(/[^A-Za-z\u00C0-\u017F]/g, '');
      return pulito.length === 1 ? letteraTrovata : 'Design';
    }
    var testoSx = daMostrare(vSx, sx), testoDx = daMostrare(vDx, dx);
    return { sx: sx, dx: dx, chiave: sx + '|' + dx, nomeSx: nomeSx, nomeDx: nomeDx,
             testoSx: testoSx, testoDx: testoDx, etichetta: testoSx + '-' + testoDx,
             conDisegno: (testoSx === 'Design' || testoDx === 'Design'),
             bundle: bundle, nomeBundle: nomeBundle };
  }
  function paia(cart){
    var out = [];
    (cart.items || []).forEach(function(it){
      if (eAccessorio(it)) return;
      var ini = inizialiDi(it);
      if (!ini) return;
      for (var i = 0; i < it.quantity; i++) out.push({ ini: ini, item: it });
    });
    return out;
  }
  function haPackaging(cart){
    return (cart.items || []).some(function(it){
      if (!eAccessorio(it)) return false;
      var T = String(it.title || '').toUpperCase();
      if (T.indexOf('NESSUN') > -1 || T.indexOf('SOLO CALZE') > -1) return false;
      return it.price > 0;
    });
  }
  function lordo(cart){
    return (cart.items || []).reduce(function(s, i){
      return s + (typeof i.original_line_price === 'number' ? i.original_line_price : i.line_price || 0);
    }, 0);
  }
  function genere(cart){
    var g = null;
    (cart.items || []).some(function(it){
      if (eAccessorio(it)) return false;
      var T = String(it.product_title || it.title || '').toUpperCase();
      if (T.indexOf('DONNA') > -1) { g = 'donna'; return true; }
      if (T.indexOf('UOMO') > -1) { g = 'uomo'; return true; }
      return false;
    });
    return g;
  }

  // a quale famiglia appartiene una riga: prima il metafield, poi il prezzo come riserva
  function famigliaDi(item, mappa){
    var h = item.handle || String(item.url || '').split('/products/')[1] || '';
    h = h.split('?')[0];
    if (mappa && mappa[h]) return mappa[h];
    var p = typeof item.original_price === 'number' ? item.original_price : (item.price || 0);
    if (p >= 5700) return 'extrafine';
    if (p === 3400 || p === 3900) return 'stirato';
    return 'barattoli';
  }

  // le paia divise per famiglia, ognuna col conto delle coppie di lettere uguali
  function famiglie(cart, mappa){
    var gruppi = { barattoli: [], stirato: [], extrafine: [] };
    paia(cart).forEach(function(x){
      var f = famigliaDi(x.item, mappa);
      if (!gruppi[f]) f = 'barattoli';
      gruppi[f].push(x);
    });
    var fuori = {};
    Object.keys(gruppi).forEach(function(f){
      var elenco = gruppi[f], chiavi = {};
      elenco.forEach(function(x){ chiavi[x.ini.chiave] = (chiavi[x.ini.chiave] || 0) + 1; });
      // due paia "A-B" stanno in una confezione doppia anche se in carrello c'e' anche una
      // "C-D", che prendera' la sua singola: le coppie si contano dentro ogni gruppo di
      // lettere e poi si sommano
      var coppie = 0, resto = 0;
      Object.keys(chiavi).forEach(function(k){
        coppie += Math.floor(chiavi[k] / 2);
        resto += chiavi[k] % 2;
      });
      fuori[f] = {
        elenco: elenco,
        paia: elenco.length,
        // qui "stesseIniziali" vuol dire "c'e' almeno una coppia da mettere insieme":
        // e' cosi' che lo legge is-packaging per scegliere la misura doppia
        stesseIniziali: coppie > 0,
        coppie: coppie,
        resto: resto
      };
    });
    return fuori;
  }

  function stato(cart, mappa){
    var p = paia(cart), chiavi = {};
    p.forEach(function(x){ chiavi[x.ini.chiave] = (chiavi[x.ini.chiave] || 0) + 1; });
    // qui invece serve il senso stretto — TUTTE le paia con le stesse due lettere — perche'
    // e' la condizione dello sconto PAIO10
    var stesse = p.length >= 2 && Object.keys(chiavi).length === 1;
    return {
      paia: p.length,
      elenco: p,
      stesseIniziali: stesse,
      coppie: stesse ? Math.floor(p.length / 2) : 0,
      haPackaging: haPackaging(cart),
      lordo: lordo(cart),
      genere: genere(cart),
      famiglie: famiglie(cart, mappa)
    };
  }
  function daMostrare(cart){
    var s = stato(cart);
    return s.paia > 0 && !s.haPackaging;
  }

  // ---- dove mandano i pulsanti ---------------------------------------------------------

  function paginaCollezioni(cart){
    return ROOT + 'pages/collezioni-' + (genere(cart) === 'donna' ? 'donna' : 'uomo');
  }
  function aggiornaLink(cart){
    var url = paginaCollezioni(cart);
    document.querySelectorAll('.is-continua, .is-doppio__scegli').forEach(function(a){
      a.setAttribute('href', url);
    });
    return url;
  }

  // ---- ridisegno senza ricaricare ------------------------------------------------------

  function sezioni(){
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function(h){
      var s = h.closest('[id^="shopify-section-"]');
      if (!s) return;
      var id = s.id.replace('shopify-section-', '');
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }
  function conSezioni(corpo){
    var ids = sezioni();
    if (ids.length) {
      corpo.sections = ids.join(',');
      corpo.sections_url = window.location.pathname;
    }
    return corpo;
  }
  function applica(risposta){
    var sez = risposta && risposta.sections;
    if (!sez) return false;
    var fatto = false;
    Object.keys(sez).forEach(function(id){
      var html = sez[id];
      if (!html) return;
      var contenitore = document.getElementById('shopify-section-' + id);
      if (!contenitore) return;
      var vecchio = contenitore.querySelector('cart-items-component');
      if (!vecchio) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nuovo = doc.querySelector('cart-items-component');
      if (!nuovo) return;
      vecchio.innerHTML = nuovo.innerHTML;
      fatto = true;
    });
    /* IS 29/08/2026 — l'evento va emesso con la stessa forma che usa il tema.
       Com'era: new CustomEvent('cart:update') senza detail. I componenti di Horizon
       leggono event.detail.data?.itemCount: con detail nullo la lettura falliva prima
       del ?., il gestore si interrompeva e il numero sull'icona del carrello non veniva
       piu' riscritto. Si vedeva dopo "Aggiungi il secondo paio": carrello 2 articoli,
       icona ferma a 1 (misurato il 28/08).
       Falliva in tre punti: cart-icon.js, component-cart-items.js e is-doppio-paio.js.
       La forma qui sotto ricalca CartUpdateEvent di assets/events.js:
         detail = { resource, sourceId, data: {...} }
       cosi' resta valida anche dopo un aggiornamento del tema. */
    if (fatto) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: risposta,
          sourceId: 'is-regole-packaging',
          data: {
            source: 'is-regole-packaging',
            itemCount: (risposta && typeof risposta.item_count === 'number') ? risposta.item_count : undefined
          }
        }
      }));
    }
    return fatto;
  }
  function scrivi(percorso, corpo){
    return fetch(ROOT + percorso, {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify(conSezioni(corpo))
    }).then(function(r){
      if (r.ok) return r.json();
      // Shopify spiega perche' ha detto di no, e lo dice nella lingua del negozio: quasi
      // sempre e' una lettera esaurita su quel modello. Il messaggio viaggia con l'errore,
      // cosi' il componente puo' mostrarlo al posto di un "Riprova" che non aiuta nessuno.
      return r.json().catch(function(){ return null; }).then(function(j){
        var motivo = j && (j.description || j.message);
        var errore = new Error(motivo || percorso);
        errore.motivo = motivo || '';
        throw errore;
      });
    });
  }

  return { stato: stato, daMostrare: daMostrare, paia: paia, haPackaging: haPackaging,
           inizialiDi: inizialiDi, lordo: lordo, genere: genere, eAccessorio: eAccessorio,
           famiglie: famiglie, famigliaDi: famigliaDi,
           paginaCollezioni: paginaCollezioni, aggiornaLink: aggiornaLink,
           sezioni: sezioni, conSezioni: conSezioni, applica: applica, scrivi: scrivi };
})();

// i link vanno tenuti aggiornati anche quando è il tema a ridisegnare il carrello
(function(){
  if (window.__isLinkCollezioni) return;
  window.__isLinkCollezioni = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var attesa = null;
  function sincronizza(){
    clearTimeout(attesa);
    attesa = setTimeout(function(){
      fetch(ROOT + 'cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c) window.ISRegolePackaging.aggiornaLink(c); })
        .catch(function(){});
    }, 150);
  }
  ['cart:updated','cart:update','cart:refresh','cart:change','cart-drawer:open'].forEach(function(e){
    document.addEventListener(e, sincronizza);
  });
  document.addEventListener('shopify:section:load', sincronizza);
  window.addEventListener('pageshow', sincronizza);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sincronizza);
  else sincronizza();
})();
